import type * as CSS from 'csstype';
import { Intent } from 'enums';
import styled, { css } from 'styled-components';

/**
 * SECONDARY intent
 */
export const intentSecondary = css`
  color: ${(props) => props.theme.colors.steel};
`;

interface HeadingProps {
  textTransform?: CSS.Property.TextTransform;
}

export const Heading = styled.h1<HeadingProps>`
  ${(props) => props.theme.text.PageTitle};
  font-size: 30px;
  font-weight: 600;
  text-transform: ${({ textTransform }) => textTransform};
  margin-bottom: 0;
`;

export const HeadingLight = styled.h1<HeadingProps>`
  ${(props) => props.theme.text.PageTitle};
  font-size: 24px;
  font-weight: 400;
  text-transform: ${({ textTransform }) => textTransform};
  margin-bottom: 0;
`;

export const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.44;
  color: ${(props) => props.theme.colors.darkBlue};
  margin: 2em 0 1em 0;
`;

interface IParagraph {
  intent?: Intent;
  textAlign?: string;
  marginBottom?: string;
}

export const Paragraph = styled.p<IParagraph>`
  color: ${(props) => props.theme.colors.darkBlue};
  margin-bottom: ${(props) => props.marginBottom};
  margin-top: 0.5em;
  font-size: 14px;
  line-height: 1.5;

  > strong {
    font-weight: 600;
  }

  &:first-child {
    margin-top: 0;
  }

  & > a:link {
    text-decoration: underline;
  }

  ${(props) =>
    props.intent === Intent.SECONDARY &&
    css`
      ${intentSecondary}
    `}

  text-align: ${(props) => props.textAlign};
`;

export const BigNumber = styled.span.attrs((props) => ({
  color: props.theme.colors.darkBlue,
}))`
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.5px;
  color: ${(props) => props.color};
`;
